export const EnvironmentConst = ({
    DesktopWeb: {
        id: 1
    },
    MobileWeb: {
        id: 3
    },
    MobileApps: {
        id: 4
    },
    ConnectedTVApp: {
        id: 5
    }
});